<template>
  <div id="homeView" class="container justify-center">

    <div class="background-img-container">
      <div :class="{'background-img': true, 'hidden-left': currentPage !== 0 }"></div>
    </div>
    
    <TransitionWrapper>
      <IntroView v-if="currentPage === 0" />
    </TransitionWrapper>

    <TransitionWrapper>
      <ScreenerView v-if="currentPage === 1" />
    </TransitionWrapper>
    
    <TransitionWrapper
      v-for="({question}, index) in questions"
      :key="`${question.name}-${index}`">
      <QuestionsView
        :questionIndex="index"
        v-if="currentPage === (index + 2)"
      />
    </TransitionWrapper>

  </div>
</template>

<script>
// @ is an alias to /src
import IntroView from '@/components/IntroView.vue'
import QuestionsView from '@/components/QuestionsView.vue'
import ScreenerView from '@/components/ScreenerView.vue'
import TransitionWrapper from '@/components/TransitionWrapper.vue'

export default {
  name: 'HomeView',
  components: {
    IntroView,
    QuestionsView,
    ScreenerView,
    TransitionWrapper,
  },
  computed: {
    currentPage() {
      return this.$store.state.currentPage
    },
    questions() {
      return this.$store.state.questions
    },
    introImg() {
      return this.$store.state.intro.imgSrc
    }
  },
  beforeMount() {
    this.$store.commit("setNumberOfPages")
  }
}
</script>

<style lang="scss">
  #homeView {
    display: flex;
    height: 100%;
    overflow-x: hidden;
    padding-left: 1em;
    padding-right: 1em;
    position: relative;
    width: 100%;
    min-height: 100vh;

    @media print, screen and (min-width: 48em) {
      padding: 0;
    }

    .background-img-container {
      bottom: 0;
      display: none;
      height: 100vh;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      top: 0;
      width: 100vw;

      @media print, screen and (min-width: 48em) {
        display: block;
      }

      .background-img {
        background-image: url(../assets/images/intro/AH_calculator_HERO_Image.png);
        background-position: top left;
        background-repeat: no-repeat;
        background-size: cover;
        bottom: 0;
        height: 100%;
        left: 0;
        opacity: 1;
        position: relative;
        right: 0;
        top: 0;
        transform: translateX(0);
        transition: transform 1s, opacity 1s;
        width: 100%;
        
        &.hidden-left {
          opacity: 0;
          transform: translateX(-110%);
        }
      }
    }
  }
</style>
